export function to_title_case(arg_string: string): string {
    return arg_string.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

export function vendor_name_to_id(arg_vendor_name: string): number {
    if (arg_vendor_name == "3E") {
        return 1
    } else if (arg_vendor_name == "CED") {
        return 2
    } else if (arg_vendor_name == "Crescent") {
        return 3
    } else if (arg_vendor_name == "Republic Electric") {
        return 4
    } else if (arg_vendor_name == "Van Meter") {
        return 5
    } else if (arg_vendor_name == "Altorfer") {
        return 6
    } else if (arg_vendor_name == "Anixter") {
        return 7
    } else if (arg_vendor_name == "Duke Rentals") {
        return 8
    } else if (arg_vendor_name == "Sunbelt") {
        return 9
    } else if (arg_vendor_name == "Echo") {
        return 10
    }

    return 0
}

export function vendor_id_to_name(arg_vendor_id: number): string {
    if (arg_vendor_id == 1) {
        return "3E"
    } else if (arg_vendor_id == 2) {
        return "CED"
    } else if (arg_vendor_id == 3) {
        return "Crescent"
    } else if (arg_vendor_id == 4) {
        return "Republic Electric"
    } else if (arg_vendor_id == 5) {
        return "Van Meter"
    } else if (arg_vendor_id == 6) {
        return "Altorfer"
    } else if (arg_vendor_id == 7) {
        return "Anixter"
    } else if (arg_vendor_id == 8) {
        return "Duke Rentals"
    } else if (arg_vendor_id == 9) {
        return "Sunbelt"
    } else if (arg_vendor_id == 10) {
        return "Echo"
    }
 
    return ""
}

export const vendors = {
    "3E": 1,
    "CED": 2,
    "Crescent": 3,
    "Republic Electric": 4,
    "Van Meter": 5,
    "Altorfer": 6,
    "Anixter": 7,
    "Duke Rentals": 8,
    "Sunbelt": 9,
    "Echo": 10,
}